class SubcontentController {
  constructor(
    $rootScope,
    $scope,
    $timeout,
    $interval,
    $stateParams,
    $sanitize,
    homeService,
    toastr,
    $location
  ) {
    'ngInject';
    this.name = 'subcontent';
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.homeService = homeService;
    this.$sanitize = $sanitize;
    this.$location = $location;
    $rootScope.page = this.name;
    this.loading = true;
    this.content = null;
    this.contentArray = [];
    $rootScope.id = $stateParams.id;
    $rootScope.subid = $stateParams.subid;
    $rootScope.packet = $location.search().p;
    $rootScope.$broadcast('CHANGE_LOGO');

    if (
      $rootScope.config &&
      $rootScope.config.tokenHeader &&
      $rootScope.config.tokenHeader['x-access-token']
    ) {
      this.loggedIn = true;
    }

    // Identify Language
    if (
      this.$rootScope.language == undefined &&
      this.$stateParams.lang == null
    ) {
      this.$rootScope.language = 'de';
      $rootScope.$broadcast('GET_MENU');
    } else if (this.$rootScope.language == undefined) {
      this.$rootScope.language = this.$stateParams.lang;
      $rootScope.$broadcast('GET_MENU');
    }

    /**
     * Function to be called if the current page has a transition
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $scope.$on('$locationChangeSuccess', (event, data) => {
      $rootScope.id = $stateParams.id;
      $rootScope.$broadcast('CHANGE_LOGO');
      // Identify Language
      if (
        this.$rootScope.language == undefined &&
        this.$stateParams.lang == null
      ) {
        this.$rootScope.language = 'de';
        $rootScope.$broadcast('GET_MENU');
      } else if (this.$rootScope.language == undefined) {
        this.$rootScope.language = this.$stateParams.lang;
        $rootScope.$broadcast('GET_MENU');
      }
      // Reset Scrolling
      jQuery('.app').animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });

    /**
     * Function to be called when the content gets saved
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $scope.$on('SAVE', (event, data) => {
      this.content = this.contentArray.join('<span class="pagebreak"></span>');
      this.homeService
        .setContent(this.$stateParams.subid, this.content)
        .then((result) => {
          toastr.success('Die Seite wurde erfolgreich gespeichert.');
        });
    });

    /**
     * Function to be called when the content gets saved
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $scope.$on('CANCEL', (event, data) => {
      this.content = angular.copy(this.contentBackup);
      this.contentArray = this.content.split('<span class="pagebreak"></span>');
    });

    this.getContent();
  }

  getContent() {
    this.homeService
      .getContent(this.$stateParams.subid, this.$stateParams.lang)
      .then((result) => {
        this.content = this.$sanitize(result.data.text);
        this.contentBackup = angular.copy(this.content);

        if (result.data.editable == undefined) {
          this.$rootScope.editable = false;
        } else {
          this.$rootScope.editable = true;
        }
        // img replace workaround
        this.content = this.content
          .split('logo.php/')
          .join('https://www.eigenkapitalforum.com/logo.php/');
        this.contentArray = this.content.split(
          '<span class="pagebreak"></span>'
        );

        if (this.$stateParams.subid == 285 || this.$stateParams.subid == 284) {
          this.galerie = [];
          this.images = this.contentArray[0].match(/src="([^"]*)"/g);
          angular.forEach(this.images, (value, key) => {
            value = value.replace('src="', '').replace('"', '');
            this.galerie.push(value);
          });
        }

        this.$timeout(() => {
          this.loading = false;

          this.$timeout(() => {
            jQuery('.content-cube').each(function() {
              jQuery(this).css(
                'height',
                jQuery(this)
                  .children('.content-cube-html')
                  .height() + 70
              );
              jQuery(this).css(
                'height',
                jQuery(this)
                  .children('img')
                  .height() + 70
              );
              jQuery(this).css(
                'height',
                jQuery(this)
                  .children('div')
                  .children('.content-cube-html')
                  .height() + 70
              );
              jQuery(this).css(
                'height',
                jQuery(this)
                  .children('div')
                  .children('div')
                  .children('.content-cube-html')
                  .height() + 70
              );
            });

            // Workaround
            setInterval(function() {
              jQuery('.content-cube').each(function() {
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('.content-cube-html')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('img')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('div')
                    .children('.content-cube-html')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('div')
                    .children('div')
                    .children('.content-cube-html')
                    .height() + 70
                );
              });
            }, 1000);
            jQuery('.container').css(
              'height',
              jQuery('.container')
                .find('.subContainer')
                .height()
            );
          }, 0);
        }, 0);
      });
  }
}

export default SubcontentController;



// WEBPACK FOOTER //
// ./client/app/components/home/subcontent/subcontent.controller.js